import { useEffect, useState } from 'react';
import { api, type CustomFieldDef } from '../api';
import { OBJECTS } from '../config';

const TYPES = ['text', 'number', 'date', 'boolean', 'select', 'multiselect'];

export function CustomFieldsAdmin() {
  const [objectType, setObjectType] = useState(OBJECTS[0].key);
  const [defs, setDefs] = useState<CustomFieldDef[]>([]);
  const [fieldKey, setFieldKey] = useState('');
  const [label, setLabel] = useState('');
  const [dataType, setDataType] = useState('text');
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setDefs(await api.get<CustomFieldDef[]>(`/api/custom-fields/${objectType}`));
  }

  useEffect(() => {
    void load().catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectType]);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await api.post(`/api/custom-fields/${objectType}`, { fieldKey, label, dataType });
      setFieldKey('');
      setLabel('');
      await load();
    } catch {
      setError('Create failed (need customfields.manage permission, and a lower_snake_case key).');
    }
  }

  async function remove(id: string) {
    await api.del(`/api/custom-fields/def/${id}`);
    await load();
  }

  return (
    <div className="card">
      <h1>Custom fields</h1>
      <label className="field">
        <span>Object</span>
        <select value={objectType} onChange={(e) => setObjectType(e.target.value)}>
          {OBJECTS.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
        </select>
      </label>

      <table className="grid">
        <thead><tr><th>Key</th><th>Label</th><th>Type</th><th></th></tr></thead>
        <tbody>
          {defs.map((d) => (
            <tr key={d.id}>
              <td>{d.fieldKey}</td><td>{d.label}</td><td>{d.dataType}</td>
              <td><button className="btn" onClick={() => void remove(d.id)}>Delete</button></td>
            </tr>
          ))}
          {defs.length === 0 && <tr><td colSpan={4} className="empty">No custom fields yet.</td></tr>}
        </tbody>
      </table>

      <form className="row" onSubmit={create} style={{ marginTop: '1rem' }}>
        <input placeholder="field_key" value={fieldKey} onChange={(e) => setFieldKey(e.target.value)} />
        <input placeholder="Label" value={label} onChange={(e) => setLabel(e.target.value)} />
        <select value={dataType} onChange={(e) => setDataType(e.target.value)}>
          {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
        <button className="btn btn-primary" type="submit">Add field</button>
      </form>
      {error && <p style={{ color: '#b91c1c' }}>{error}</p>}
    </div>
  );
}
